import gql from "graphql-tag"

export const getShoppingCartQueryGQL = gql`
  query getShoppingCartQuery {
    getShoppingCart {
      statusCode
      errorMessage
      subTotal
      itemCount
      cartItems {
        _id
        image
        quantity
        amount
        originalPrice
        sizeLabel
        colorCode
        colorName
        brandName
        productName
        skuCode
        sku
        branchId
      }
    }
  }
`
//b2b
export const saveCartItemGQL = gql`
  mutation saveCartItemMutation($skuCode: String, $quantity: Int, $sku: String) {
    saveCartItem(skuCode: $skuCode, quantity: $quantity, sku: $sku) {
      statusCode
      errorMessage
      success
      updatedCartItem {
        _id
      }
    }
  }
`
//b2b
export const removeFromCartGQL = gql`
  mutation removeFromCartMutation($_id: String) {
    removeFromCart(_id: $_id) {
      statusCode
      errorMessage
      success
      updatedCartItem {
        _id
      }
    }
  }

`


export const addToCartMutationGQL = gql`
  mutation addToCartMutation($cartItem: CartItemInput) {
    addToCart(cartItem: $cartItem) {
      statusCode
      errorMessage
      success
    }
  }
`

export const removeFromCartMutationGQL = gql`
  mutation removeFromCartMutation($cartItem: CartItemInput) {
    removeFromCart(cartItem: $cartItem) {
      statusCode
      errorMessage
      success
    }
  }
`

export const getInventoryBySkuIdQueryGQL = gql`
  query getInventoryBySkuIdQuery($skuId: String) {
    getInventoryBySkuId(skuId: $skuId)
  }
`

export const adjustCartMutationGQL = gql`
  mutation adjustCart {
    adjustCart
  }
`
